import { render } from "./FormularioPessoaJuridica.vue?vue&type=template&id=2db50b1a"
import script from "./FormularioPessoaJuridica.vue?vue&type=script&lang=js"
export * from "./FormularioPessoaJuridica.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__